export * from './GalleryBlock';

import { GalleryBlock } from './GalleryBlock';

export default GalleryBlock;
